import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/variables.css';
import './styles/App.css';
import HomePage from './pages/HomePage';
import ImprintPage from './pages/ImprintPage';
import ReferencesPage from './pages/ReferencesPage';
import PolicyPage from './pages/PolicyPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/imprint" element={<ImprintPage />} />
          <Route path="/references" element={<ReferencesPage />} />
          <Route path="/policy" element={<PolicyPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
